import Icon from '../components/Icon.vue'

Icon.register({
  scroll: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M48 0c26.5 0 48 21.5 48 48v80h-80c-8.8 0-16-7.2-16-16v-64c0-26.5 21.5-48 48-48zM256 412.6c0 31.9-21.8 61.4-53.3 66.5-40.1 6.5-74.8-24.3-74.8-63.1v-368c0-18.1-6.3-34.6-16.4-48h336.4c52.9 0 96 43.1 96 96v256h-288v60.6zM288 384h336c8.8 0 16 7.2 16 16 0 61.9-50.1 112-112 112h-336c52.9 0 96-43.1 96-96v-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/scroll.js
// module id = 1863
// module chunks = 0